


















































































import marked from 'marked';
import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import BlueHeroBanner from '~/components/UIComponents/BlueHeroBanner.vue';
import InfoCard from '~/components/UIComponents/InfoCard.vue';
import { ICurrentPage } from '~/store/types';

@Component({
  components: { BlueHeroBanner, InfoCard },
})
export default class GetGalaPage extends Vue {
  @Mutation updateCurrentPage!: (payload: ICurrentPage) => void;

  marked = marked;

  get ways() {
    return [
      {
        number: 1,
        title: this.$t('pages.getGala.ownAndOperate.heading'),
        text: this.$t('pages.getGala.ownAndOperate.text'),
        btnText: this.$t('common.cta.getANode'),
        route: '/nodes/founders-node/buy',
        imgSrc: 'https://static.gala.games/images/get-gala/icon_getnode.png',
      },
      {
        number: 2,
        title: this.$t('pages.getGala.buyFromExchange.heading'),
        text: this.$t('pages.getGala.buyFromExchange.text'),
        imgSrc: 'https://static.gala.games/images/get-gala/icon_exchange.png',
      },
    ];
  }

  get infoCards() {
    return [
      {
        uniqueId: 'get-gala-smart-contract',
        title: this.$t('pages.getGala.smartContract.heading'),
        imgSrc: require('@/assets/icons/icon_node_ecosystem.png'),
        content: this.$t('pages.getGala.smartContract.text'),
        btnText: this.$t('pages.getGala.smartContract.cta'),
        link:
          'https://etherscan.io/token/0xd1d2Eb1B1e90B638588728b4130137D262C87cae',
      },
      {
        uniqueId: 'node-community',
        title: this.$t('pages.getGala.decentralization.heading'),

        imgSrc: require('@/assets/icons/icon_node_community.png'),
        content: this.$t('pages.getGala.decentralization.heading'),
        btnText: this.$t('common.cta.readMore'),
        link:
          'https://blog.gala.games/the-gala-games-node-ecosystem-9760d8156af7',
      },
    ];
  }
  galaCube = require('@/assets/icons/icon_gala_cube.png');

  async created() {
    this.updateCurrentPage({
      title: 'Get GALA',
      backIcon: 'arrow_back_ios',
      backRoute: `/`,
    });
  }

  goTo(route: string) {
    this.$router.push(route);
  }
}
